import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState = {};

const siteConfigDetails = createSlice({
	name: 'siteConfigDetails',
	initialState,
	reducers: {
		siteConfigDetailsAdded(state, action) {
			if (state) {
				return action.payload;
			}
			return state;
		}
	}
});

export const useSiteConfigDetails = () =>
	useSelector((state) => state.siteConfig);

export const { siteConfigDetailsAdded } = siteConfigDetails.actions;

export default siteConfigDetails.reducer;
